"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var orderRouter = {
  type: 1,
  path: '/sms-account-management',
  component: _layout.default,
  redirect: '/sms-account-management/password-update',
  name: '',
  meta: {
    title: 'personalAccountManagement',
    icon: 'g-agent'
  },
  children: [{
    type: 2,
    path: 'password-update',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-account-management/password-update'));
      });
    },
    name: 'account:updatePassword',
    meta: {
      title: 'passwordUpdate'
    },
    children: []
  }, {
    type: 2,
    path: 'pay-password-update',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-account-management/pay-password-update'));
      });
    },
    name: 'account:updatePayPassword',
    meta: {
      title: 'payPasswordUpdate'
    },
    children: []
  }, {
    type: 2,
    path: 'system-config',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-account-management/system-config'));
      });
    },
    name: 'agentSystemConfig:add',
    meta: {
      title: 'systemConfig'
    },
    children: []
  }, {
    type: 2,
    path: 'bind-google-code',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-account-management/bind-google-code'));
      });
    },
    name: 'account:bindGoogle',
    meta: {
      title: 'bindGoogleCode'
    },
    children: []
  }]
};
var _default = orderRouter;
exports.default = _default;